/**
 * holz4home — Ambassador Overlay
 * Floating Panel + Apply-Modal. Aktiv nur, wenn sessionStorage["h4h_amb_active"] === "1".
 * Reagiert auf Shopify-Cart-Updates via /cart.js Polling + Storefront-Events.
 */
(function () {
  'use strict';

  const KEYS = {
    active: 'h4h_amb_active',
    profile: 'h4h_amb_profile',
    tiers: 'h4h_amb_tiers',
    collapsed: 'h4h_amb_collapsed',
  };

  if (sessionStorage.getItem(KEYS.active) !== '1') return;

  const CFG = window.H4H_AMB_CONFIG || {};
  let profile = {};
  let tiers = [];
  try { profile = JSON.parse(sessionStorage.getItem(KEYS.profile) || '{}'); } catch (_) {}
  try { tiers   = JSON.parse(sessionStorage.getItem(KEYS.tiers)   || '[]'); } catch (_) {}

  if (!profile || !profile.session) {
    // Inconsistenter State -> Session beenden
    cleanup();
    return;
  }

  const tierLimit = computeLimitEur(profile, tiers);

  // ===== DOM ===========================================================
  const root = document.createElement('div');
  root.className = 'h4h-amb';
  root.innerHTML = `
    <button class="h4h-amb__pill" type="button" aria-label="Bewerbungs-Panel oeffnen">
      <span class="h4h-amb__pill-dot"></span>
      <span>Bewerbung · <span class="h4h-amb__pill-total">0 €</span></span>
      <span class="h4h-amb__pill-chev">
        <svg viewBox="0 0 12 12" fill="none" stroke="currentColor" stroke-width="2" stroke-linecap="round"><path d="M2 8l4-4 4 4"/></svg>
      </span>
    </button>

    <aside class="h4h-amb__panel" role="dialog" aria-label="Bewerbungs-Warenkorb">
      <header class="h4h-amb__head">
        <div class="h4h-amb__head-l">
          <span class="h4h-amb__brand"></span>
          <div>
            <div class="h4h-amb__h-title">Bewerbungs-Warenkorb</div>
            <div class="h4h-amb__h-sub">Aktive Session</div>
          </div>
        </div>
        <button class="h4h-amb__close" type="button" aria-label="Panel zuklappen">
          <svg viewBox="0 0 24 24" fill="none" stroke="currentColor" stroke-width="2" stroke-linecap="round"><path d="M6 18L18 6M6 6l12 12"/></svg>
        </button>
      </header>

      <div class="h4h-amb__body">
        <div class="h4h-amb__row">
          <span><span class="h4h-amb__count">0</span> Artikel im Warenkorb</span>
          <b class="h4h-amb__total">0,00 €</b>
        </div>

        <div>
          <div class="h4h-amb__row" style="margin-bottom:6px">
            <span class="h4h-amb__sub">Dein Wunsch-Limit</span>
            <span class="h4h-amb__sub h4h-amb__limit-label">— €</span>
          </div>
          <div class="h4h-amb__bar"><div class="h4h-amb__bar-fill"></div></div>
        </div>

        <div class="h4h-amb__meta">
          Bei <b class="h4h-amb__followers">—</b> Followern liegt dein Wunschwert bei
          <b class="h4h-amb__limit">—</b>. Das ist eine Orientierung — Ausnahmen pruefen wir gerne.
        </div>

        <div class="h4h-amb__actions">
          <button class="h4h-amb__btn h4h-amb__btn--primary h4h-amb__submit" type="button">
            Bewerbung absenden
            <svg viewBox="0 0 24 24" fill="none" stroke="currentColor" stroke-width="2.2" stroke-linecap="round"><path d="M5 12h14M13 6l6 6-6 6"/></svg>
          </button>
          <a class="h4h-amb__btn h4h-amb__btn--ghost" href="${CFG.landing_url || '/pages/ambassador'}">
            Zurueck zur Bewerbungsseite
          </a>
        </div>
      </div>
    </aside>
  `;
  document.body.appendChild(root);

  const $pill   = root.querySelector('.h4h-amb__pill');
  const $panel  = root.querySelector('.h4h-amb__panel');
  const $close  = root.querySelector('.h4h-amb__close');
  const $count  = root.querySelector('.h4h-amb__count');
  const $total  = root.querySelector('.h4h-amb__total');
  const $pillTotal = root.querySelector('.h4h-amb__pill-total');
  const $barFill   = root.querySelector('.h4h-amb__bar-fill');
  const $bar       = root.querySelector('.h4h-amb__bar');
  const $followers = root.querySelector('.h4h-amb__followers');
  const $limit     = root.querySelector('.h4h-amb__limit');
  const $limitLab  = root.querySelector('.h4h-amb__limit-label');
  const $meta      = root.querySelector('.h4h-amb__meta');
  const $submit    = root.querySelector('.h4h-amb__submit');

  // Statisches Profil-Display
  $followers.textContent = formatInt(profile.max_followers || 0);
  $limit.textContent = formatEur(tierLimit);
  $limitLab.textContent = formatEur(tierLimit);

  // Mobile-Default: collapsed (Pill). Desktop-Default: expanded.
  const mobileMQ = window.matchMedia('(max-width:640px)');
  let collapsed;
  const savedCollapsed = sessionStorage.getItem(KEYS.collapsed);
  if (savedCollapsed === null) {
    collapsed = mobileMQ.matches;
  } else {
    collapsed = savedCollapsed === '1';
  }
  applyCollapsed(true);

  let scrollIgnoreUntil = 0;
  function applyCollapsed(initial) {
    $pill.classList.toggle('is-shown', collapsed);
    $panel.classList.toggle('is-shown', !collapsed);
    if (!initial) sessionStorage.setItem(KEYS.collapsed, collapsed ? '1' : '0');
  }
  function expand() {
    collapsed = false;
    applyCollapsed(false);
    scrollIgnoreUntil = Date.now() + 450;
  }
  function collapse() {
    collapsed = true;
    applyCollapsed(false);
  }
  $pill.addEventListener('click', expand);
  $close.addEventListener('click', collapse);

  // Auto-collapse beim Scrollen (Mobile)
  window.addEventListener('scroll', () => {
    if (collapsed) return;
    if (Date.now() < scrollIgnoreUntil) return;
    if (!mobileMQ.matches) return;
    collapse();
  }, { passive: true });

  // Tap auf Hintergrund (Mobile) -> zuklappen
  $panel.addEventListener('click', (e) => { e.stopPropagation(); });
  document.addEventListener('click', (e) => {
    if (collapsed || !mobileMQ.matches) return;
    if (e.target.closest('.h4h-amb__panel') || e.target.closest('.h4h-amb__pill')) return;
    if (Date.now() < scrollIgnoreUntil) return;
    collapse();
  });

  // ===== Cart-Updates ==================================================
  let lastTotal = -1;
  async function refreshCart() {
    try {
      const cart = await fetch('/cart.js', { headers: { Accept: 'application/json' }}).then(r => r.json());
      const totalCents = cart.total_price || 0;
      const totalEur = totalCents / 100;
      const itemCount = cart.item_count || 0;
      $count.textContent = itemCount;
      $total.textContent = formatEur(totalEur);
      $pillTotal.textContent = formatEur(totalEur);
      const pct = tierLimit > 0 ? Math.min(100, (totalEur / tierLimit) * 100) : 0;
      $barFill.style.width = pct + '%';
      const over = tierLimit > 0 && totalEur > tierLimit;
      $bar.classList.toggle('is-over', over);
      $meta.classList.toggle('is-warn', over);
      if (over) {
        $meta.innerHTML = `Du liegst aktuell <b>ueber</b> deinem Wunschlimit von <b>${formatEur(tierLimit)}</b>. Das ist okay — Ausnahmen pruefen wir gerne.`;
      } else {
        $meta.innerHTML = `Bei <b>${formatInt(profile.max_followers || 0)}</b> Followern liegt dein Wunschwert bei <b>${formatEur(tierLimit)}</b>. Das ist eine Orientierung — Ausnahmen pruefen wir gerne.`;
      }
      lastTotal = totalCents;
      return cart;
    } catch (e) {
      console.warn('[h4h-amb] cart fetch failed', e);
      return null;
    }
  }
  refreshCart();

  // Cart-Aenderungen via Polling + Shopify-Events abfangen
  setInterval(refreshCart, 5000);
  document.addEventListener('cart:updated', refreshCart);            // Dawn / div. Themes
  document.addEventListener('cart:refresh', refreshCart);
  document.addEventListener('ajaxCart.afterCartLoad', refreshCart);  // Liquid Ajax Cart
  window.addEventListener('focus', refreshCart);

  // Auch bei jeder POST auf /cart/* triggern wir einen Refresh
  const _fetch = window.fetch;
  window.fetch = function (...args) {
    const p = _fetch.apply(this, args);
    try {
      const url = (typeof args[0] === 'string') ? args[0] : (args[0] && args[0].url) || '';
      const opt = args[1] || {};
      if (/\/cart(\/|\.js)/.test(url) && opt.method && opt.method.toUpperCase() !== 'GET') {
        p.then(() => setTimeout(refreshCart, 100));
      }
    } catch (_) {}
    return p;
  };

  // ===== Apply-Modal ===================================================
  $submit.addEventListener('click', openApplyModal);

  function openApplyModal() {
    const cart = lastTotal >= 0 ? null : null;
    refreshCart().then((cart) => {
      const m = buildModal(cart);
      document.body.appendChild(m);
      requestAnimationFrame(() => m.classList.add('is-shown'));
    });
  }

  function buildModal(cart) {
    const itemCount = cart ? cart.item_count : 0;
    const totalEur = cart ? (cart.total_price || 0) / 100 : 0;

    const m = document.createElement('div');
    m.className = 'h4h-amb-modal';
    m.innerHTML = `
      <div class="h4h-amb-modal__box" role="dialog" aria-modal="true" aria-labelledby="h4h-amb-modal-title">
        <header class="h4h-amb-modal__head">
          <div>
            <h3 id="h4h-amb-modal-title">Bewerbung abschicken</h3>
            <p>Schritt 2 von 2 — kurz vorstellen, abschicken, fertig.</p>
          </div>
          <button class="h4h-amb-modal__close" type="button" aria-label="Schliessen">
            <svg viewBox="0 0 24 24" fill="none" stroke="currentColor" stroke-width="2" stroke-linecap="round"><path d="M6 18L18 6M6 6l12 12"/></svg>
          </button>
        </header>

        <div class="h4h-amb-modal__recap">
          <div class="h4h-amb-modal__recap-row"><span>Name</span><b>${escapeHtml(profile.name || '—')}</b></div>
          <div class="h4h-amb-modal__recap-row"><span>E-Mail</span><b>${escapeHtml(profile.email || '—')}</b></div>
          <div class="h4h-amb-modal__recap-row"><span>Plattformen</span><b>${renderPlatformsSummary(profile.platforms)}</b></div>
          <div class="h4h-amb-modal__recap-row"><span>Warenkorb</span><b>${itemCount} Artikel · ${formatEur(totalEur)}</b></div>
        </div>

        <div class="h4h-amb-modal__body">
          <div class="h4h-amb-modal__err" role="alert"></div>
          <label>
            <span>Erzaehl uns kurz, was du mit den Produkten vorhast *</span>
            <textarea name="content_plan" placeholder="Z.B.: Drei Reels zum Aufbau, 1 Story-Highlight mit Q&amp;A, eine Pinterest-Pin-Serie ..." required></textarea>
          </label>
          <label>
            <span>Wo finden wir dich zusaetzlich? (optional)</span>
            <input type="text" name="extra_links" placeholder="Website, weitere Profile, Portfolio ...">
          </label>
          <div aria-hidden="true" style="position:absolute;left:-9999px;width:1px;height:1px;overflow:hidden">
            <label>Lass dieses Feld leer<input type="text" name="_hp" tabindex="-1" autocomplete="off"></label>
          </div>
        </div>

        <div class="h4h-amb-modal__cta">
          <button class="h4h-amb-modal__submit" type="button">
            Bewerbung jetzt absenden
            <svg viewBox="0 0 24 24" fill="none" stroke="currentColor" stroke-width="2.2" stroke-linecap="round"><path d="M5 12h14M13 6l6 6-6 6"/></svg>
          </button>
        </div>
      </div>`;

    const close = () => { m.classList.remove('is-shown'); setTimeout(() => m.remove(), 200); };
    m.querySelector('.h4h-amb-modal__close').addEventListener('click', close);
    m.addEventListener('click', (e) => { if (e.target === m) close(); });
    document.addEventListener('keydown', function esc(e) {
      if (e.key === 'Escape') { close(); document.removeEventListener('keydown', esc); }
    });

    m.querySelector('.h4h-amb-modal__submit').addEventListener('click', () => submitApplication(m));
    return m;
  }

  async function submitApplication(modal) {
    const btn = modal.querySelector('.h4h-amb-modal__submit');
    const err = modal.querySelector('.h4h-amb-modal__err');
    const planEl = modal.querySelector('textarea[name="content_plan"]');
    const linksEl = modal.querySelector('input[name="extra_links"]');
    const hpEl = modal.querySelector('input[name="_hp"]');

    err.classList.remove('is-shown');
    const plan = planEl.value.trim();
    if (plan.length < 10) {
      err.textContent = 'Bitte beschreibe deine Idee in ein paar Saetzen (mind. 10 Zeichen).';
      err.classList.add('is-shown');
      return;
    }

    btn.disabled = true;
    btn.innerHTML = 'Wird abgeschickt ...';

    try {
      const cart = await fetch('/cart.js', { headers: { Accept: 'application/json' }}).then(r => r.json());
      const cartTotalEur = (cart.total_price || 0) / 100;
      const overLimit = tierLimit > 0 && cartTotalEur > tierLimit;

      const payload = {
        session_id: profile.session,
        submitted_at: new Date().toISOString(),
        source: 'shopify-storefront',
        _hp: hpEl ? hpEl.value : '',
        applicant: {
          name: profile.name,
          email: profile.email,
          platforms: profile.platforms,
          max_followers: profile.max_followers,
        },
        tier_hint: {
          label: profile.tier ? profile.tier.label : null,
          limit_eur: tierLimit,
          cart_total_eur: cartTotalEur,
          over_limit: overLimit,
        },
        content_plan: plan,
        extra_links: linksEl.value.trim() || null,
        cart: cart,
      };

      const res = await fetch(CFG.endpoint, {
        method: 'POST',
        headers: { 'Content-Type': 'application/json', 'Accept': 'application/json' },
        body: JSON.stringify(payload),
      });

      if (res.status === 429) {
        return startCooldown(btn, err, 120,
          'Zu viele Anfragen. Bitte in 2 Minuten erneut versuchen.');
      }

      let data = null;
      try { data = await res.json(); } catch (_) {}

      if (!res.ok) {
        let msg = (data && data.message) || 'Etwas ist schiefgegangen.';
        if (data && Array.isArray(data.fields) && data.fields.length) {
          msg = msg + ' (' + data.fields.join(', ') + ')';
        }
        throw new Error(msg);
      }

      showSuccess(modal);
      cleanup();
    } catch (e) {
      err.textContent = e.message || 'Etwas ist schiefgegangen. Bitte versuche es erneut.';
      err.classList.add('is-shown');
      btn.disabled = false;
      btn.innerHTML = 'Erneut versuchen';
    }
  }

  function startCooldown(btn, err, seconds, msg) {
    err.textContent = msg;
    err.classList.add('is-shown');
    btn.disabled = true;
    const update = () => {
      btn.innerHTML = 'In ' + seconds + 's erneut versuchen';
      if (seconds <= 0) {
        btn.disabled = false;
        btn.innerHTML = 'Erneut versuchen';
        err.classList.remove('is-shown');
        return;
      }
      seconds -= 1;
      setTimeout(update, 1000);
    };
    update();
  }

  function showSuccess(modal) {
    const box = modal.querySelector('.h4h-amb-modal__box');
    box.innerHTML = `
      <div class="h4h-amb-modal__ok">
        <div class="h4h-amb-modal__ok-icon">
          <svg viewBox="0 0 24 24" fill="none" stroke="currentColor" stroke-width="2.4" stroke-linecap="round"><path d="M5 12l5 5L20 7"/></svg>
        </div>
        <h3>Danke! Wir melden uns persoenlich.</h3>
        <p>Joshua liest deine Bewerbung selbst und antwortet in der Regel innerhalb von 7 Tagen.</p>
        <a class="h4h-amb__btn h4h-amb__btn--ghost" style="display:inline-flex;color:#1f2624;border-color:rgba(31,38,36,.16)" href="/">Weiter im Shop stoebern</a>
      </div>`;
    // Overlay weg
    root.remove();
  }

  // ===== Helpers =======================================================
  function computeLimitEur(profile, tiers) {
    if (!Array.isArray(tiers) || !tiers.length) return 0;
    const followers = (profile && profile.max_followers) || 0;
    const sorted = [...tiers].sort((a, b) => (a.max_followers || 0) - (b.max_followers || 0));
    const t = sorted.find(x => followers <= (x.max_followers || 0)) || sorted[sorted.length - 1];
    return (t && t.warenwert_eur) || 0;
  }
  function formatEur(n) {
    return new Intl.NumberFormat('de-DE', { style: 'currency', currency: 'EUR', maximumFractionDigits: 2 }).format(n);
  }
  function formatInt(n) {
    return new Intl.NumberFormat('de-DE').format(n);
  }
  function escapeHtml(s) {
    return String(s == null ? '' : s).replace(/[&<>"']/g, (c) => ({ '&': '&amp;', '<': '&lt;', '>': '&gt;', '"': '&quot;', "'": '&#39;' }[c]));
  }
  function renderPlatformsSummary(arr) {
    if (!Array.isArray(arr) || !arr.length) return '—';
    return arr.map(p => `${escapeHtml(p.platform)} ${escapeHtml(p.handle || '')} (${formatInt(p.followers || 0)})`).join('<br>');
  }
  function cleanup() {
    sessionStorage.removeItem(KEYS.active);
    sessionStorage.removeItem(KEYS.profile);
    sessionStorage.removeItem(KEYS.tiers);
    sessionStorage.removeItem(KEYS.collapsed);
    // Cart-Attributes loeschen (best effort)
    fetch('/cart/update.js', {
      method: 'POST',
      headers: { 'Content-Type': 'application/json' },
      body: JSON.stringify({
        attributes: {
          '_h4h_amb_session': '',
          '_h4h_amb_name': '',
          '_h4h_amb_email': '',
          '_h4h_amb_platforms': '',
          '_h4h_amb_max_followers': '',
          '_h4h_amb_tier_limit_eur': '',
        },
      }),
    }).catch(() => {});
  }
})();
